import { renderPreviewComponent } from '@/utils/previewComponentMap';
import { Fragment } from 'react/jsx-runtime';
import { PhraseFormField } from './PhraseFormField';
import { Control } from 'react-hook-form';
import {
  CategorizedPhraseKey,
  getPhraseCategory,
} from '@/config/phrase-contract';
import {
  PlannerConfigEntityPhraseStrings,
  PlannerConfigEntityWithOptionalFields,
} from '@/services/configurator/PlannerConfigTypes';
import { PhraseFieldSection } from './PhraseFieldSection';

export type PreviewablePhraseFieldsProps = {
  categorizedPhraseKey: CategorizedPhraseKey;
  phraseFormControl: Control<PlannerConfigEntityWithOptionalFields>;
  watchedPhraseStrings: PlannerConfigEntityPhraseStrings;
  watchedPlanner: PlannerConfigEntityWithOptionalFields;
  disableFields?: boolean;
  fieldClassName?: string;
  className?: string;
  syncedPhraseKeys?: Set<string>;
};

export function PreviewablePhraseFields({
  categorizedPhraseKey,
  phraseFormControl,
  watchedPhraseStrings,
  watchedPlanner,
  disableFields,
  fieldClassName,
  className,
  syncedPhraseKeys,
}: PreviewablePhraseFieldsProps) {
  const phraseCategory = getPhraseCategory({ component: categorizedPhraseKey });

  const renderSectionContents = () => {
    return (
      <Fragment>
        {phraseCategory.phraseKeys?.map((phraseKey: string) => (
          <Fragment key={phraseKey}>
            <PhraseFormField
              phraseKey={phraseKey}
              phraseFormControl={phraseFormControl}
              disabled={disableFields}
              className={fieldClassName}
              syncedPhraseKeys={syncedPhraseKeys}
            />
          </Fragment>
        ))}
      </Fragment>
    );
  };

  return (
    <div className={`mt-8 flex flex-row gap-8 ${className ?? ''}`}>
      <PhraseFieldSection
        sectionTitle={phraseCategory.text}
        sectionDescription={phraseCategory.description ?? ''}
        renderSectionContents={renderSectionContents}
        sectionDescriptionVisible
        sectionClassName='w-1/2'
      />
      {renderPreviewComponent(
        categorizedPhraseKey,
        watchedPhraseStrings ?? {},
        watchedPlanner,
        watchedPlanner.contentPageSectionVisibility,
        watchedPlanner.contentPageVariant,
      )}
    </div>
  );
}
